import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

import Home from './Components/Home';
import Table from './Components/Table';
import Graphics from './Components/Graphics';
import Form from './Components/Form';
import Login from './Components/Login';
import Layout from './Components/Layout';
import TableAuth from './Components/TableAuth';
import FormAuth from './Components/FormAuth';
import FormDenominators from './Components/FormDenominators'
import ProtectedRoute from "./utils/ProtectedRoutes";


function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (loggedUser) => {
    setUser(loggedUser);
    localStorage.setItem("user", JSON.stringify(loggedUser));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={user ? "/home" : "/login"} replace />} />

        <Route
          path="/login"
          element={
            user
              ? <Navigate to="/home" replace />
              : <Login onLoginSuccess={handleLoginSuccess} />
          }
        />

        {user ? (
          <Route element={<Layout onLogout={handleLogout} />}>
            <Route path="/home" element={<Home />} />
            <Route path="/tabla" element={<Table />} />
            <Route path="/graficas" element={<Graphics />} />

            <Route
              path="/formulario"
              element={
                <ProtectedRoute user={user} allowedRoles={[1,2,6]}>
                  <Form />
                </ProtectedRoute>
              }
            />

            <Route
              path="/autorizacion"
              element={
                <ProtectedRoute user={user} allowedRoles={[1,2,4]}>
                  <TableAuth />
                </ProtectedRoute>
              }
            />

            <Route
              path="/detalle/:preguntaId"
              element={
                <ProtectedRoute user={user} allowedRoles={[1,2,4]}>
                  <FormAuth />
                </ProtectedRoute>
              }
            />

            <Route
              path="/denominadores"
              element={
                <ProtectedRoute user={user} allowedRoles={[1,2,4]}>
                  <FormDenominators />
                </ProtectedRoute>
              }
            />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}

      </Routes>
    </BrowserRouter>
  );
}

export default App;